module.exports = __webpack_public_path__ + "static/img/14.1cee70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/14.png
// module id = GXGQ
// module chunks = 0